/*
 * Copyright (C) 2019 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */

import { DataService } from './data.service';
import { Injectable } from '@angular/core';
import { NamedValue } from 'app/shared/models';
import { Observable } from 'rxjs';
import { StaticDataType } from 'app/static-data/models';
import { observableOf, observableThrow } from 'app/shared/rxjs/rxjs.utils';

/** Returns mock data. */
@Injectable()
export class MockDataService extends DataService {
  loadEnumerationValues(enumType: StaticDataType): Observable<NamedValue<string>[]> {
    switch (enumType) {
      case 'ccp':
        return this.valueArray(['CME', 'LCH', 'EUREX']);
      case 'configType':
        return this.valueArray(['Config Type 1', 'Config Type 2', 'Config Type 3']);
      case 'currency':
      case 'reportingCurrency':
        return this.valueArray(['USD', 'EUR', 'JPY', 'GBP']);
      case 'customReportType':
        return this.valueArray(['REPORT_TYPE_FOO', 'REPORT_TYPE_BAR', 'REPORT_TYPE_BAZ']);
      case 'emailType':
        return this.valueArray([
          'FILE_ATTACHMENT',
          'PARSING_AND_CALCULATION_STATUS',
          'THIRD_VALUE'
        ]);
      case 'filter':
        return this.valueArray(['ETD_FUTURE', 'ETD_OPTION']);
      case 'fileFormat':
        return this.valueArray([
          'Strata:Position-CSV',
          'ClientData:Portfolio',
          'ClientData:PortfolioFileSet'
        ]);
      case 'outputConverterType':
        return this.valueArray(['GENERIC', 'IM_DETAILS']);
      case 'outputGrouping':
        return this.valueArray(['Broker', 'Ccp', 'Currency', 'Desk', 'Fund', 'Strategy', 'Trade']);
      case 'portfolioMarginModel':
        return this.valueArray(['DRIM', 'DEB']);
      case 'reportingCalcMeasure':
        return this.valueArray([
          'Initial Margin',
          'Marginal IM',
          'Market Rate DV01',
          'Present Value',
          'Benchmark Par Rate',
          'Benchmark Margin Ratio',
          'GNA IM',
          'GNA Marginal IM',
          'GNA Total IM',
          'GNA Marginal Total IM'
        ]);
      case 'reportPostProcessorType':
        return this.valueArray(['POST_PROCESSOR_FOO', 'POST_PROCESSOR_BAR', 'POST_PROCESSOR_BAZ']);
      default:
        return observableThrow(new Error('Unexpected enumType: ' + enumType));
    }
  }

  private valueArray(values: string[]): Observable<NamedValue<string>[]> {
    return observableOf(values.map(value => this.toNamedValue(value)));
  }

  private toNamedValue(item: string): NamedValue<string> {
    return {
      name: item,
      value: item
    };
  }
}
